import {vue} from '@/main'
import * as authService from '@/data/api/auth'

export interface AuthAppList {
  accountsApplicationUrl: string,
  applications: {
    [key: string]: {
      homeUrl: string | null,
      pushUrl: string | null,
    },
  }
}

export async function getAppList(): Promise<AuthAppList | null> {
  try {
    const r = await authService.api.get('/app/list')
    if (!r) { return null }
    const data = getAppListTransform(r.data)
    vue.$store.commit('setAppList', data)
    return data
  } catch (err) {
    console.log('getAppList', err)
    return null
  }
}

function getAppListTransform(data: any): AuthAppList {
  const filteredData: AuthAppList = {applications: {}, accountsApplicationUrl: data.accountsApplicationUrl}
  for (const item of data.applications) {
    filteredData.applications[item.app] = {homeUrl: item.homeUrl || null, pushUrl: item.pushUrl || null}
  }
  return filteredData
}
